import { faPlus, faTrashCan } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TextField } from '@tryhackme/thm-ui-components';
import { useMemo } from 'react';
import { FrequencyType } from 'src/common/enums/categorization-dashboard';
import { Controller, useFormContext, useWatch } from 'src/common/form';
import { useGetRuleTitlesQuery } from '../../categorization.slice';
import { StyledButton as FrequencyButton } from '../accordion/accordion.styles';
import { Frequency } from '../frequency/frequency';
import { StyledFormGroup } from '../rule/rule.styles';
import { StyledButton, StyledCard, StyledRow } from './nested-rule.styles';
import type { NestedRuleProps } from './nested-rule.types';
export const NestedRule = ({
  path,
  currentRuleId,
  handleRemove
}: NestedRuleProps) => {
  const {
    data,
    isLoading
  } = useGetRuleTitlesQuery(currentRuleId);
  const {
    control,
    register,
    setValue
  } = useFormContext();

  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const [ruleId, frequency] = useWatch({
    control,
    name: [`${path}.ruleId`, `${path}.frequency`]
  });
  const ruleOptions = useMemo(() => {
    if (isLoading) {
      return [];
    }
    return data?.rules?.map(rule => ({
      label: rule.title,
      value: rule._id
    })) || [];
  }, [data?.rules, isLoading]);
  const selectedRule = useMemo(() => ruleOptions.find(rule => rule.value === ruleId), [ruleId, ruleOptions]);
  const parameters: string[] = data?.rules.find(rule => rule._id === ruleId)?.parameters ?? [];
  const handleAddFrequency = () => {
    setValue(`${path}.frequency`, {
      type: FrequencyType.EVENTS
    });
  };

  // eslint-disable-next-line unicorn/no-useless-undefined
  const handleRemoveFrequency = () => setValue(`${path}.frequency`, undefined);
  return <StyledRow data-sentry-element="StyledRow" data-sentry-component="NestedRule" data-sentry-source-file="nested-rule.tsx">
      <StyledCard data-sentry-element="StyledCard" data-sentry-source-file="nested-rule.tsx">
        <StyledRow data-sentry-element="StyledRow" data-sentry-source-file="nested-rule.tsx">
          <StyledFormGroup data-sentry-element="StyledFormGroup" data-sentry-source-file="nested-rule.tsx">
            <Controller control={control} name={`${path}.ruleId`} render={({
            field: {
              onChange
            }
          }) => <TextField placeholder="Rule" variant="select" isMulti={false} selected={selectedRule} options={ruleOptions} isSearchable isDisabled={isLoading} handleSelection={option => {
            setValue(`${path}.parameters`, {});
            onChange(option?.value);
          }} />} data-sentry-element="Controller" data-sentry-source-file="nested-rule.tsx" />
            <StyledButton variant="outlined" color="secondary" onClick={handleRemove} data-sentry-element="StyledButton" data-sentry-source-file="nested-rule.tsx">
              <FontAwesomeIcon icon={faTrashCan} data-sentry-element="FontAwesomeIcon" data-sentry-source-file="nested-rule.tsx" />
            </StyledButton>
          </StyledFormGroup>
        </StyledRow>
        {parameters.length > 0 && <StyledRow>
            <p>Parameters</p>
          </StyledRow>}
        {parameters.map(parameter => <StyledRow key={parameter}>
            <StyledFormGroup>
              <TextField {...register(`${path}.parameters.${parameter}`)} id={`parameters-${parameter}`} placeholder="Value" variant="input" label={`{${parameter}}`} labelPosition="left" isDisabled={isLoading} />
            </StyledFormGroup>
          </StyledRow>)}
        {!frequency && <StyledRow>
            <StyledFormGroup>
              <FrequencyButton variant="text" color="secondary" size="small" onClick={handleAddFrequency}>
                <FontAwesomeIcon icon={faPlus} /> Add frequency
              </FrequencyButton>
            </StyledFormGroup>
          </StyledRow>}
        {frequency && <Frequency path={path} handleRemove={handleRemoveFrequency} />}
      </StyledCard>
    </StyledRow>;
};